import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './redux/store';
import 'react-calendar/dist/Calendar.css';
import keycloak from './hooks/keycloak';
import { initAkkuConsent } from './consent/akkuConsent';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Akku consent. Only wires listeners here -- the SDK itself is not initialised until someone is
// signed in, so nothing consent-related renders on the login page: no banner, and no floating
// "Manage preferences" control. See src/consent/akkuConsent.ts for why that has to be init() and not
// just the prompt, and for why it creates no gap where tags could run unconsented.
initAkkuConsent();

// ⛳ INIT KEYCLOAK FIRST
const initializeApp = async (): Promise<void> => {
  try {
    const authenticated: boolean = await keycloak.init({
      checkLoginIframe: false,
      pkceMethod: "S256",
    });

    root.render(
      <Provider store={store}>
        <App />
      </Provider>
    );
  } catch (error) {
    console.error('Keycloak initialization failed:', error);
    root.render(
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <h1 style={{ color: '#e74c3c' }}>Authentication Error</h1>
        <p>Unable to connect to authentication server.</p>
        <button onClick={() => window.location.reload()} style={{ padding: '8px 16px', marginTop: '10px' }}>
          Retry
        </button>
      </div>
    );
  }
};

initializeApp();

reportWebVitals();